import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.stringify.js";
import Protection from "../components/Modal/Protection.vue";
import ValidMFA from "../components/Modal/ValidMFA.vue";
import { refreshI18nAuthInfo } from "../../lang";
import _ from "lodash";
import { getUUID } from "@/libs/url";
import { mapActions, mapState, mapMutations } from "vuex";
import { setUnitNumber, getUnitNumber, setLocalWx, getAccountType, setPasswordType } from "@/libs/auth";
import { entryUnit, unitsTree, unitsForOig } from "@/service/user";
import { pushWxMsg } from "@/service/wx";
import { hasHttp, getRedirect } from "@/libs/url";
import { auth } from "@/service/cas";
import SecondCheck from "../components/SecondCheck.vue";
import FootLanguage from "@/components/Layout/footLanguage.vue";
import store from "store2";
import SwitchingUnit from "@/components/login-unit/switching-unit.vue";
import Cookies from "js-cookie";
import { authorizeWithOAuth2 } from "../service/oauth";
import tipModal from "@/components/Modal/tipModal.vue";
import { isWeiXinLogin, isMobileJs } from "@/utils/util.js";
import { getWxLoginUrl } from "@/service/wx";
import { enterpriseHome, admin_menu } from "@/libs/menu-list.js";
import { getMobileLoginDestination } from "@/utils/login-destination";
import { pushRecentUnit } from "@/utils/recent-units";
import LoginMain from "./Login/login-main.vue";
import WechatQuickLogin from "@/views/Login/wechat-quick-login.vue";
import QRCODE from "@/views/Login/qrcode.vue";
export default {
  components: {
    SecondCheck,
    FootLanguage,
    SwitchingUnit,
    Protection,
    ValidMFA,
    tipModal,
    LoginMain,
    WechatQuickLogin,
    QRCODE
  },
  data() {
    return {
      login: {
        loginType: getAccountType() || "MOBILE",
        // 登录方式
        formData: {
          mobile: "",
          email: "",
          mobileAreaCode: "+86"
        },
        loginAgreement: false,
        // 登录协议
        loading: false,
        // 登录loading
        showEWM: false // 快捷登录条件之一，false-打开，true-关闭
      },
      switchUnitLoading: false,
      isInviteLink: false,
      savedUserInfo: store.get("userInfo") || {},
      sendMessage: false,
      showGZH: false,
      //打开公众号关注页面
      showAuthMFA: false,
      //校验FMA
      authMFA: "",
      // MFA 弹窗打开时仅模糊登录后的页面，不改变单位选择业务状态。
      isMfaPending: false,
      // 仅记录本次 MFA 进入前是否已有单位，用于取消未绑定流程时决定是否清理 cookie。
      mfaUnitIdExistedBeforeEntry: null,
      currentUnit: {},
      units: [],
      uuid: getUUID(),
      unitTreeDate: [],
      protocalInterNum: 3
    };
  },
  computed: {
    ...mapState({
      user: state => state.user,
      isLogin: state => state.user.isLogin,
      language: state => state.app.language,
      mfaSettings: state => state.user.mfaSettings,
      userinfo: state => state.user.userinfo,
      appCode: state => state.app.appCode
    }),
    isPcClient() {
      return /(Windows|Macintosh|Linux|X11)/i.test(navigator.userAgent);
    },
    showSavedLogin() {
      var _this$savedUserInfo;
      return ((_this$savedUserInfo = this.savedUserInfo) === null || _this$savedUserInfo === void 0 ? void 0 : _this$savedUserInfo.isBindWechat) === "T";
    },
    // 微信快捷登录
    _wxQuickLogin() {
      return this.showSavedLogin && !this.login.showEWM && !(isMobileJs() && !isWeiXinLogin());
    }
  },
  async mounted() {
    const {
      inviteCode,
      mobile,
      email,
      language
    } = this.$route.query;
    if (this.isLogin) {
      if (inviteCode) {
        //进入加入页面
        this.$router.replace({
          path: "/join",
          query: {
            ...this.$route.query,
            userId: this.user.userInfo.userId
          }
        });
      } else {
        this.unitLoading = true;
        this.getUnits();
      }
    } else {
      // 判断是否在微信环境
      if (isWeiXinLogin()) {
        // 主动登出后不自动发起企微静默登录，避免
        // "登出 → 刷新 → 静默重登 → 误判未登录" 的死循环；
        // 用户点击头像登录时清除该标记。
        if (sessionStorage.getItem("loggedOut") === "1") {
          return;
        }
        this.jumpWxLoign();
      }
    }
    //判断链接上是否有参数 有则是通过邀请链接进入

    if (inviteCode) {
      if (mobile && email) {
        this.login.loginType = "MOBILE";
      } else if (email) {
        this.login.loginType = "EMAIL";
      }
      if (mobile.indexOf("-") > -1) {
        //手机号存在区号 拆分区号和手机号
        const arr = mobile.split("-");
        this.mobileEmail({
          mobile: arr[1],
          email: email || "",
          mobileAreaCode: arr[0]
        });
      } else {
        this.mobileEmail({
          mobile: mobile || "",
          email: email || ""
        });
      }
      this.setLanguage(language);
      this.isInviteLink = true;
    }
  },
  methods: {
    ...mapActions(["handleLogin", "getUserInfo", "handleLogOut", "handlePhoneSubmit", "handleEmailSubmit", "reqMFAConfigs"]),
    ...mapMutations(["setLanguage", "setLogin", "setPersonConfig"]),
    /*
     * login的修改
     */
    handleChange(e) {
      var _e$loginType, _e$loginAgreement, _e$loading, _e$showEWM;
      const {
        formData = {}
      } = e;
      this.login = {
        loginType: (_e$loginType = e.loginType) !== null && _e$loginType !== void 0 ? _e$loginType : this.login.loginType,
        loginAgreement: (_e$loginAgreement = e.loginAgreement) !== null && _e$loginAgreement !== void 0 ? _e$loginAgreement : this.login.loginAgreement,
        loading: (_e$loading = e.loading) !== null && _e$loading !== void 0 ? _e$loading : this.login.loading,
        showEWM: (_e$showEWM = e.showEWM) !== null && _e$showEWM !== void 0 ? _e$showEWM : this.login.showEWM,
        formData: {
          ...this.login.formData,
          ...formData
        }
      };
    },
    async jumpWxLoign() {
      const res = await getWxLoginUrl();
      const {
        qrCode
      } = res.data.retVal;
      let wx = {
        login: "T",
        redirect: this.$route.query.redirect || ""
      };
      setLocalWx(wx);
      window.location.href = qrCode;
    },
    cancel() {
      this.cleanupUnboundMfaUnitId();
      this.isMfaPending = false;
      if (this.units.length === 1 && this.units[0].children.length === 0) {
        this.sendMessage = false;
        this.$store.commit("setLogin", false);
      }
    },
    confirm(issuer, unitCode) {
      this.$refs.protection.open(issuer, unitCode);
    },
    clearMfaUnitIdTracking() {
      this.mfaUnitIdExistedBeforeEntry = null;
    },
    cleanupUnboundMfaUnitId() {
      if (this.mfaUnitIdExistedBeforeEntry === null) return;

      // 未进入过单位时移除本次预写入的单位；已有单位时保留当前 cookie。
      if (!this.mfaUnitIdExistedBeforeEntry) {
        Cookies.remove("unitId");
      }
      this.clearMfaUnitIdTracking();
    },
    //邮箱/手机号验证码登录时，两者不存在
    noMobileEmail() {
      if (this.isInviteLink) {
        this.$router.replace({
          path: "/regist",
          query: {
            ...this.$route.query,
            accountType: this.login.loginType
          }
        });
      }
    },
    async validSuccess() {
      var _this$$refs$protectio;
      const {
        query
      } = this.$route;
      const {
        client_id
      } = query;
      // 登录页完成 MFA 后直接收起绑定弹窗，成功关闭不能回落到 validCancel。
      (_this$$refs$protectio = this.$refs.protection) === null || _this$$refs$protectio === void 0 || _this$$refs$protectio.close(false);
      // MFA 已校验成功，本次临时单位状态不再允许被后续取消逻辑清理。
      this.clearMfaUnitIdTracking();
      // MFA 验证通过后必须确认单位会话已生效，失败时不能继续伪进入首页。
      let userInfoResult;
      try {
        // MFA 完成后已经进入单位，并行恢复用户信息和翻译身份。
        [userInfoResult] = await Promise.all([this.getUserInfo(), refreshI18nAuthInfo().catch(() => false)]);
      } catch {
        this.isMfaPending = false;
        return;
      }
      if (!userInfoResult || userInfoResult.result !== 0) {
        this.isMfaPending = false;
        return;
      }
      this.isMfaPending = false;
      if (query.protocol === "SAML") {
        location.href = "/api/sso/samlAuth";
      } else {
        if (client_id) {
          // newxtcloud跳转
          const res2 = await authorizeWithOAuth2(query);
          if (res2.data && res2.data.result === 0) {
            location.href = res2.data.retVal;
          }
        } else {
          // 单位进入，将unitId设置进入cookie
          // 如果没有CASTGC 退出
          if (!Cookies.get("CASTGC")) {
            this.handleLogOut();
          } else {
            this.go(this.currentUnit.code);
          }
        }
      }
    },
    validCancel() {
      this.cleanupUnboundMfaUnitId();
      this.isMfaPending = false;
      if (this.units.length === 1 && this.units[0].children.length === 0) {
        this.sendMessage = false;
        this.$store.commit("setLogin", false);
      }
    },
    /*
     ** 密码登录流程
     */
    async handleSubmit({
      mobile,
      password,
      accountType,
      mobileAreaCode
    }) {
      this.login.loading = true;
      if (!this.login.loginAgreement) {
        this.$Message.warning($t("xsngcsh", "请阅读后勾选同意用户协议、隐私政策"));
        this.login.loading = false;
        return;
      }
      const res = await this.handleLogin({
        mobile,
        password,
        accountType,
        mobileAreaCode,
        isLink: this.isInviteLink ? "T" : ""
      });
      if (res && res.result === 0 && !_.has(res.retVal, "mobile")) {
        if (this.isInviteLink) {
          //有账号 直接进入加入页面
          this.$router.replace({
            path: "/join",
            query: {
              ...this.$route.query,
              userId: res.retVal
            }
          });
        } else {
          // 邮箱、手机密码登录标识
          setPasswordType("password");
          // 开始选择单位
          this.getUnits(res);
        }
      } else if (res && res.result === 10008 && this.isInviteLink) {
        //没有账号 通过邀请链接进入并且返回10000 跳转到注册页
        this.$router.replace({
          path: "/regist",
          query: {
            ...this.$route.query,
            accountType: this.login.loginType
          }
        });
      }
      this.login.loading = false;
    },
    /*
     ** 短信登录流程
     */
    async handleSubmitWithPhone(body) {
      this.login.loading = true;
      if (!this.login.loginAgreement) {
        this.$Message.warning($t("xsngcsh", "请阅读后勾选同意用户协议、隐私政策"));
        this.login.loading = false;
        return;
      }
      const res = await this.handlePhoneSubmit(body);
      if (res && res.result === 0) {
        if (this.isInviteLink) {
          //有账号 直接进入加入页面
          this.$router.replace({
            path: "/join",
            query: {
              ...this.$route.query,
              userId: res.retVal
            }
          });
        } else {
          // 开始选择单位
          this.getUnits(res);
        }
      } else if (res && res.result === 10008 && this.isInviteLink) {
        //没有账号 通过邀请链接进入并且返回10000 跳转到注册页
        this.$router.replace({
          path: "/regist",
          query: {
            ...this.$route.query,
            accountType: this.login.loginType
          }
        });
      }
      this.login.loading = false;
    },
    /*
     ** 邮箱验证码登录流程
     */
    async handleSubmitWithEmail(body) {
      this.login.loading = true;
      if (!this.login.loginAgreement) {
        this.$Message.warning($t("xsngcsh", "请阅读后勾选同意用户协议、隐私政策"));
        this.login.loading = false;
        return;
      }
      const res = await this.handleEmailSubmit(body);
      if (res && res.result === 0) {
        if (this.isInviteLink) {
          //有账号 直接进入加入页面
          this.$router.replace({
            path: "/join",
            query: {
              ...this.$route.query,
              userId: res.retVal
            }
          });
        } else {
          // 开始选择单位
          this.getUnits(res);
        }
      } else if (res && res.result === 10008 && this.isInviteLink) {
        //没有账号 通过邀请链接进入并且返回10000 跳转到注册页
        this.$router.replace({
          path: "/regist",
          query: {
            ...this.$route.query,
            accountType: this.login.loginType
          }
        });
      }
      this.login.loading = false;
    },
    /*
     ** 判断显示单位选择还是直接进入单位
     */
    judgeWay(units) {
      // 如果没有CASTGC 退出
      if (!Cookies.get("CASTGC")) {
        this.handleLogOut();
      } else {
        setUnitNumber(units);
        const redirectUnit = this.findRedirectUnit(units);
        if (redirectUnit) {
          this.setUniTreeData(units);
          this.currentUnit = redirectUnit;
          this.goHome(redirectUnit);
          return;
        }
        if (units.length === 0) {
          // 个人账号直接放行
          this.go();
        }
        // 如果只有一个单位，直接进入单位
        else if (units.length === 1 && units[0].children.length === 0) {
          this.currentUnit = units[0];
          this.goHome(units[0]);
        } else {
          this.setUniTreeData(units);
        }
      }
    },
    /*
     * 赋值单位属性结构数据
     */
    setUniTreeData(units) {
      const unitIconMap = {
        ALLIANCE: enterpriseHome.icon,
        GC: enterpriseHome.icon,
        GROUP: admin_menu[1].icon,
        CHAIN: admin_menu[1].icon,
        HOTEL: admin_menu[4].icon,
        SCENIC_AREA: admin_menu[4].icon,
        SCENIC_SPOT: admin_menu[4].icon,
        CATERING_CHAIN_LIKE: admin_menu[4].icon,
        CATERING: admin_menu[4].icon,
        MANAGE: admin_menu[4].icon
      };
      // 默认全部展开
      let change = arr => {
        arr.forEach(v => {
          this.$set(v, "expand", true);
          this.$set(v, "icon", unitIconMap[v.type] || enterpriseHome.icon);
          if (v.unitId === Cookies.get("unitId")) {
            this.$set(v, "defaultChecked", true);
          }
          if (v.children && v.children.length > 0) {
            change(v.children);
          }
        });
      };
      change(units);
      this.unitTreeDate = units;
    },
    // redirect 中携带 unitCode 时，优先匹配单位树 code，命中后复用原进入单位流程。
    findRedirectUnit(units) {
      const unitCode = this.getRedirectUnitCode();
      if (!unitCode) return null;
      return this.findUnitByCode(units, unitCode);
    },
    // redirect 可能是内部路径或外部 URL，这里只解析其中的 unitCode 参数，不改变原 redirect 内容。
    getRedirectUnitCode() {
      const redirect = getRedirect(location.search, location.hash);
      if (!redirect) return "";
      const decodedRedirect = this.decodeRedirectForUnitCode(redirect);
      const matched = decodedRedirect.match(/(?:^|[?&#])unitCode=([^&#]*)/);
      if (!matched) return "";
      return this.decodeRedirectForUnitCode(matched[1]).trim();
    },
    // 登录链接中的 redirect 可能被编码多次，解析 unitCode 前最多解码三次避免漏匹配。
    decodeRedirectForUnitCode(value = "") {
      let decodedValue = String(value);
      for (let index = 0; index < 3; index += 1) {
        try {
          const nextValue = decodeURIComponent(decodedValue);
          if (nextValue === decodedValue) break;
          decodedValue = nextValue;
        } catch (error) {
          break;
        }
      }
      return decodedValue;
    },
    // 单位树存在多级结构，自动进入时需递归查找与 redirect.unitCode 完全一致的单位。
    findUnitByCode(units = [], unitCode = "") {
      for (const unit of units) {
        if (String(unit.code || unit.unitCode || "").trim() === unitCode) {
          return unit;
        }
        const matchedChild = this.findUnitByCode(unit.children || [], unitCode);
        if (matchedChild) return matchedChild;
      }
      return null;
    },
    // 手动改选单位时，用当前选择的单位 code 替换 redirect.unitCode，避免继续跳原失败单位。
    replaceRedirectUnitCode(redirect = "", unitCode = "") {
      if (!redirect || !unitCode) return redirect;
      const decodedRedirect = this.decodeRedirectForUnitCode(redirect);
      if (!/(?:^|[?&#])unitCode=/.test(decodedRedirect)) return redirect;
      return decodedRedirect.replace(/([?&#]unitCode=)[^&#]*/, `$1${encodeURIComponent(unitCode)}`);
    },
    /*
     ** 获取单位列表
     */
    async getUnits(loginResult) {
      // 登录态已建立后优先处理移动端 destination，避免进入单位选择及单位 MFA 流程。
      const destination = getMobileLoginDestination(loginResult, isMobileJs());
      if (this.isLogin && destination) {
        window.location.href = destination;
        return;
      }
      let protocol = this.$route.query.protocol;
      if (protocol && protocol === "SAML") {
        this.onJoinSAML();
      } else {
        // 存储登录方式
        store.set("accountType", this._wxQuickLogin ? "wxLogin" : this.login.loginType);
        this.switchUnitLoading = true;
        let res = await unitsTree();
        if (res.data && res.data.result === 0) {
          let units = res.data.retVal;
          this.units = units;
          let unitOne = units.length === 1 && units[0].children.length === 0;
          this.judgeWay(units);

          // 防止一个单位时闪屏出现
          if (!unitOne) {
            this.switchUnitLoading = false;
          }
        } else {
          this.switchUnitLoading = false;
        }
      }
    },
    /*
     * 获取单位列表-SAML
     */
    async getUnitsSAML() {
      this.switchUnitLoading = true;
      let gcInstanceCode = this.$route.query["gc-instance-code"];
      let params = gcInstanceCode ? {
        "gc-instance-code": gcInstanceCode
      } : {};
      let res = await unitsForOig(params);
      if (res.data && res.data.result === 0) {
        let units = res.data.retVal;
        setUnitNumber(units);
        let unitOne = units.length === 1 && units[0].children.length === 0;
        let change = arr => {
          arr.forEach(v => {
            v.unitId = v.uuid;
            if (v.children && v.children.length > 0) {
              change(v.children);
            }
          });
        };
        change(units);
        if (units.length !== 0) {
          // 如果只有一个单位，直接进入单位
          if (unitOne) {
            this.currentUnit = units[0];
            this.goHome(units[0]);
          } else {
            this.setUniTreeData(units);
          }
        }

        // 防止一个单位时闪屏出现
        if (!unitOne) {
          this.switchUnitLoading = false;
        }
      } else {
        // 报错可以退出
        this.switchUnitLoading = false;
      }
    },
    /*
     ** 选择单位
     */
    async onClickGoUnit(item) {
      this.currentUnit = item;
      await this.goHome(item);

      // 清除多语言缓存
      this.clearLanguage("I18N_IWORK-GIG");
      this.clearLanguage("I18N_LANGUAGE");
    },
    /*
     * 清除多语言缓存
     */
    clearLanguage(name) {
      const languageStore = store.namespace(name);
      languageStore.clearAll();
    },
    /*
     * SAML进入时逻辑处理
     */
    onJoinSAML() {
      const h = this.$createElement;
      let protocolError = this.$route.query.protocolError;
      if (protocolError && protocolError === "T") {
        let interNew = setInterval(() => {
          this.protocalInterNum = this.protocalInterNum - 1;
          if (this.protocalInterNum === 0) {
            clearInterval(interNew);
            this.$router.replace("/MGT");
          }
        }, 1000);
        this.$Message.warning({
          render: () => {
            // lg: 当前会话凭证已超时，${value}秒之后将重定向至门户首页
            return h("span", [$t("8j5buk1a", "\u5F53\u524D\u4F1A\u8BDD\u51ED\u8BC1\u5DF2\u8D85\u65F6\uFF0C${this.protocalInterNum}\u79D2\u4E4B\u540E\u5C06\u91CD\u5B9A\u5411\u81F3\u95E8\u6237\u9996\u9875", {
              "this.protocalInterNum": this.protocalInterNum
            })]);
          },
          duration: 3
        });
      } else {
        // SAML进入
        this.getUnitsSAML();
      }
    },
    /*
     ** 跳转进入来源或者home
     */
    async go(unitCode) {
      const redirect = this.replaceRedirectUnitCode(getRedirect(location.search, location.hash), unitCode);
      if (hasHttp(redirect)) {
        //外部链接 带上ticket
        const res = await auth(redirect);
        //拼接url
        if (res && res.data && res.data.result === 0) {
          this.switchUnitLoading = true;
          this.$Message.success({
            content: $t("x2c6yd9", "登录成功 正在跳转"),
            duration: 2,
            onClose() {
              window.location.href = res.data.retVal;
            }
          });
          return true;
        }
        this.switchUnitLoading = false;
        return false;
      } else {
        const to = redirect ? redirect : {
          name: Number(getUnitNumber()) > 0 ? this.$config.homeName : "MGT/communicationUser"
        };
        // 个人账号直接放行
        await this.$router.push(to);
        return true;
      }
    },
    async goWithMFA(item, {
      retVal,
      hadUnitIdBeforeEntry = false
    }) {
      const {
        query
      } = this.$route;
      const {
        client_id
      } = query;
      if (client_id) {
        // newxtcloud跳转
        const res2 = await authorizeWithOAuth2(query);
        if (res2.data && res2.data.result === 0) {
          location.href = res2.data.retVal;
        }
      } else {
        // 单位进入，将unitId设置进入cookie
        // 如果没有CASTGC 退出
        if (!Cookies.get("CASTGC")) {
          this.handleLogOut();
        } else {
          // MFA 弹窗期间保留单位选择页，并仅对其背景应用模糊效果。
          this.isMfaPending = true;
          if (retVal.bound) {
            return this.$refs.validMFA.open({
              ...retVal
            }, item);
          } else {
            // 仅未绑定 MFA 的流程会在取消时根据进入前状态清理单位 cookie。
            this.mfaUnitIdExistedBeforeEntry = hadUnitIdBeforeEntry;
            return this.$refs.tipModal.open({
              ...retVal
            }, item);
          }
        }
      }
    },
    // 安全认证
    async goHome(item) {
      const {
        query
      } = this.$route;
      const {
        client_id
      } = query;
      const hadUnitIdBeforeEntry = Boolean(Cookies.get("unitId"));
      this.switchUnitLoading = true;
      // 登录后选择单位接口调用
      let {
        data: {
          retVal,
          result
        }
      } = await entryUnit(item.unitId);
      localStorage.setItem("unit", JSON.stringify(item));
      Cookies.set("unitId", item.unitId);
      this.setPersonConfig(retVal);
      if (result === 200 || result === 0) {
        pushRecentUnit(item);
        // 进入单位后并行确认用户会话并获取翻译身份，互不作为对方的前置条件。
        const [userInfoResult] = await Promise.all([this.getUserInfo(), refreshI18nAuthInfo().catch(() => false)]);
        // this.switchUnitLoading = false;
        if (!userInfoResult || userInfoResult.result !== 0) {
          return;
        }
        if (query.protocol === "SAML") {
          location.href = "/api/sso/samlAuth";
        } else {
          if (client_id) {
            // newxtcloud跳转
            const res2 = await authorizeWithOAuth2(query);
            if (res2.data && res2.data.result === 0) {
              location.href = res2.data.retVal;
            }
          } else {
            // 单位进入，将unitId设置进入cookie
            // 如果没有CASTGC 退出
            if (!Cookies.get("CASTGC")) {
              this.handleLogOut();
            } else {
              this.go(item.code);
            }
          }
        }
      } else if (result === 25003) {
        // this.switchUnitLoading = false;
        this.goWithMFA(item, {
          retVal,
          hadUnitIdBeforeEntry
        });
      } else if (result === 26002) {
        // this.switchUnitLoading = false;
        let unitOne = this.units.length === 1 && this.units[0].children.length === 0;
        if (unitOne) {
          // this.switchUnitLoading = false;
          this.onLogout();
        }
      }
      this.switchUnitLoading = false;
    },
    /*
     ** 登出
     */
    async onLogout() {
      this.unitTreeDate = [];
      const res = await this.handleLogOut();
      if (res && res.result === 0) {
        this.$store.commit("setLogin", false);
        this.sendMessage = false;
      }
    },
    goToOther(name) {
      this.$router.push({
        name
      });
    },
    async savedLogin() {
      // 用户主动登录，解除登出标记，恢复静默登录能力
      sessionStorage.removeItem("loggedOut");
      // 判断是否是微信环境 如果是微信环境直接跳转登录
      if (isWeiXinLogin()) {
        this.jumpWxLoign();
      } else {
        this.login.loading = true;
        const uuid = await this.$refs.qrcode.getQRCode(true);
        const res = await pushWxMsg(uuid, this.savedUserInfo.userId);
        if (res.data && res.data.result == 0) {
          await this.$refs.qrcode.uuidCheckIterval(uuid);
          this.sendMessage = true;
        } else {
          this.showGZH = true;
        }
        this.login.loading = false;
      }
    }
  }
};